import { Col, Input, Label, Row } from "reactstrap";

import React, { useEffect, useState } from "react";

import { useDispatch } from "react-redux";

import StripeA from "../../../pages/charges/subscribeFirstTime/stripeA";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import CreditCardOutlinedIcon from "@mui/icons-material/CreditCardOutlined";
import AppModal from "../../Common/AppModal";

// const setStripeKey = () => {
//   switch (true) {
//     case window.location.hostname.includes("dev01"):
//       return "pk_test_51MRIbtHhMwnaPpvCUiHSNuCx33e1PbhRgtGA77k5f9tUgKe03BvOhdYvbUIQg0OHWpPVt8On7YU8LfLSkkmAgDFc00UpSc5bN1";
//     default:
//       return "pk_live_51MRIbtHhMwnaPpvCMCoKHKzVLzeucPksZgrIYMSStkOdrxXkLIrHYOtmhON1b1mG4jLZzY3DxNh8sFLl1JTBAkXk00XDnTfqLF";
//   }
// };
// const stripePromise = loadStripe(setStripeKey());

export default function AddCustomerCard({
  modalAddCustomerCard,
  setModalAddCustomerCard,
  toggleAddCustomerCard,
}) {
  const [cardStorageOptions, setCardStorageOptions] = useState(1); // 1 = Save + Default, 2 = Save only, 3 = Onetime use only
  const [clientSecret, setClientSecret] = useState("");
  const authUser = JSON?.parse(localStorage?.getItem("authUser"));
  const dispatch = useDispatch();
  const appearance = {
    theme: "stripe",
  };
  const options = {
    // passing the client secret obtained in step 3
    clientSecret,
    // Fully customizable with appearance API.
    appearance,
  };
  const [stripePromiseAPI, setStripePromiseAPI] = useState(null);
  const [loading, setLoading] = useState(false);
  const handleGetStipeSecret = () => {
    setLoading(true);
    fetch(
      "https://api2.crmit.co.uk/ci-4-jwt/public/masterpaymentcard/stripe/setupintent",
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `Bearer ${authUser?.token}`,
        },
        // body: JSON?.stringify(companyData),
      }
    )
      .then((res) => res.json())

      .then((data) => {
        setClientSecret(data.client_secret);
        setStripePromiseAPI(data?.stripe_pk);
        setLoading(false);
      });
  };
  const stripePromise =
    stripePromiseAPI !== null && loadStripe(stripePromiseAPI);
  useEffect(() => {
    handleGetStipeSecret();
    return () => {
      setClientSecret("");
    };
  }, []);
  return (
    <AppModal
      open={modalAddCustomerCard}
      onClose={toggleAddCustomerCard}
      title="Add New Card"
      icon={<CreditCardOutlinedIcon />}
      headerAccent="indigo"
      size="sm"
      hideFooter
    >
      <Row className="g-3">
            <>
              <div>
                {/*3 options Default Card Save only Onetime use only*/}
                <div className={"d-flex flex-row"}>
                  <div className="form-check form-switch pe-2">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="flexSwitchCheckDefault"
                      checked={cardStorageOptions === 1}
                      onChange={() => setCardStorageOptions(1)}
                    />
                    <Label className="form-label">Default Card</Label>
                  </div>
                  <div>
                    <div className="form-check form-switch pe-2">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="flexSwitchCheckDefault"
                        checked={cardStorageOptions === 2}
                        onChange={() => setCardStorageOptions(2)}
                      />
                      <Label className="form-label">Save Card</Label>
                    </div>
                  </div>
                  <div>
                    <div className="form-check form-switch">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="flexSwitchCheckDefault"
                        checked={cardStorageOptions === 3}
                        onChange={() => setCardStorageOptions(3)}
                      />
                      <Label className="form-label">Onetime use only</Label>
                    </div>
                  </div>
                </div>
              </div>
              {clientSecret && stripePromise && (
                <Elements stripe={stripePromise} options={options}>
                  <StripeA
                    setClientSecret={setClientSecret}
                    cardStorageOptions={cardStorageOptions}
                    setModalAddCustomerCard={setModalAddCustomerCard}
                  />
                </Elements>
              )}
            </>
          </Row>
    </AppModal>
  );
}
